import React from "react";
import ReactDOM from "react-dom";
import { FiX, FiInfo } from "react-icons/fi";

// Type-safe icon wrappers
const CloseIcon = FiX as React.FC<React.SVGProps<SVGSVGElement>>;
const InfoIcon = FiInfo as React.FC<React.SVGProps<SVGSVGElement>>;

interface SegmentInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
}

/**
 * SegmentInfoModal - Informational modal for Segment Write Key setup
 * Displays before the Nango connection flow for Segment
 */
const SegmentInfoModal: React.FC<SegmentInfoModalProps> = ({
  isOpen,
  onClose,
  onContinue,
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return ReactDOM.createPortal(
    <div className="su-modal-overlay" onClick={handleBackdropClick}>
      <div className="su-modal" style={{ maxWidth: "500px" }}>
        {/* Header */}
        <div className="su-modal-header">
          <div className="su-modal-title">
            <InfoIcon style={{ width: "20px", height: "20px" }} />
            <span>SEGMENT REQUIRES A WRITE KEY</span>
          </div>
          <button type="button" className="su-modal-close" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>

        {/* Body */}
        <div className="su-modal-body" style={{ padding: "24px" }}>
          <p
            style={{
              color: "#D1D5DB",
              marginBottom: "20px",
              fontSize: "14px",
              lineHeight: "1.6",
            }}
          >
            Segment uses a Write Key for authentication instead of OAuth.
          </p>

          <div
            style={{
              backgroundColor: "rgba(102, 126, 234, 0.1)",
              border: "1px solid rgba(102, 126, 234, 0.3)",
              padding: "16px",
              borderRadius: "6px",
              marginBottom: "20px",
            }}
          >
            <p
              style={{
                color: "#D1D5DB",
                fontSize: "14px",
                lineHeight: "1.6",
                margin: 0,
              }}
            >
              To get your Segment Write Key:{" "}
              <ol style={{ margin: "12px 0 0 0", paddingLeft: "20px" }}>
                <li style={{ marginBottom: "8px" }}>Log in to your Segment workspace</li>
                <li style={{ marginBottom: "8px" }}>Navigate to <strong>Connections &gt; Sources</strong></li>
                <li style={{ marginBottom: "8px" }}>Select your source (or create a new one)</li>
                <li style={{ marginBottom: "8px" }}>Copy the <strong>Write Key</strong> from the source settings</li>
              </ol>
              <a
                href="https://segment.com/docs/connections/sources/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "#667eea",
                  textDecoration: "underline",
                  fontWeight: 600,
                  display: "inline-block",
                  marginTop: "12px",
                }}
              >
                View Segment Sources Documentation
              </a>
            </p>
          </div>

          <p
            style={{
              color: "#9CA3AF",
              fontSize: "14px",
              lineHeight: "1.6",
              marginBottom: 0,
            }}
          >
            Once you have your Write Key, click Continue to connect.
          </p>
        </div>

        {/* Footer */}
        <div className="su-modal-footer" style={{ justifyContent: "space-between" }}>
          <button
            type="button"
            className="su-btn-secondary"
            onClick={onClose}
            style={{
              padding: "10px 20px",
              fontSize: "13px",
              fontWeight: "600",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            Close
          </button>
          <button
            type="button"
            onClick={onContinue}
            style={{
              padding: "10px 24px",
              backgroundColor: "#667eea",
              color: "#FFFFFF",
              border: "1px solid #667eea",
              borderRadius: "4px",
              cursor: "pointer",
              fontWeight: "600",
              fontSize: "13px",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#5568d3";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#667eea";
            }}
          >
            Continue
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default SegmentInfoModal;
